import * as React from 'react';

function SvgTwitterColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="TwitterColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={2}
        y={2}
        width={26}
        height={26}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2.146h25.697v25.697H2V2.146z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#TwitterColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.697 22.565a5.28 5.28 0 01-5.28 5.278H7.28A5.28 5.28 0 012 22.565V7.425a5.28 5.28 0 015.28-5.279h15.137a5.28 5.28 0 015.28 5.28v15.14z"
          fill="#1DA1F2"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.788 22.44c6.754 0 10.447-5.595 10.447-10.447 0-.158-.003-.317-.011-.474a7.446 7.446 0 001.831-1.901 7.355 7.355 0 01-2.108.578 3.693 3.693 0 001.615-2.031 7.389 7.389 0 01-2.332.892 3.67 3.67 0 00-6.35 2.51c0 .288.032.567.094.838A10.433 10.433 0 017.406 8.57a3.669 3.669 0 001.137 4.901 3.644 3.644 0 01-1.663-.46l-.001.047a3.673 3.673 0 002.944 3.6 3.623 3.623 0 01-1.657.062 3.676 3.676 0 003.43 2.55A7.363 7.363 0 016.16 20.79a10.382 10.382 0 005.628 1.65z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgTwitterColour;
